import React from "react";

import { mdiPlayCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import Block from "../block/Block";
import Player from "../player/Player";

import type { GetMediaResponse, MediaChildren } from "../../api/MediaAPI.types";

interface PreviewPlayerPanelProps {
  item: GetMediaResponse | MediaChildren;
  isReadyToPlay: boolean;
}

export default function PreviewPlayerPanel({
  item,
  isReadyToPlay,
}: PreviewPlayerPanelProps): React.JSX.Element {
  const { t } = useTranslation("editor-content");

  return (
    <Block
      isFullSize
      withoutPadding
      bodyStyle="h-full items-center bg-black flex"
      classNameHeader="h-[4.375rem]"
      title={t("previewPlayerPanelTitle")}
    >
      <div className="relative size-full bg-black">
        {isReadyToPlay ? (
          <div className="absolute inset-0">
            <Player isFullSize autoPlay={false} item={item} />
          </div>
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5">
            <Icon
              className="text-foreground"
              path={mdiPlayCircleOutline}
              size={2.5}
            />
            <p className="text-muted-foreground text-base font-medium">
              {t("noPreviewAvailable")}
            </p>
            <p className="text-muted-foreground text-sm">
              {t("encodeMediaToPreview")}
            </p>
          </div>
        )}
      </div>
    </Block>
  );
}
